/**
 * Extracts the decoded claims from a JWT.
 * DOES NOT VERIFY THE SIGNATURE.
 */
export function getDecodedClaims(jwt: string): Record<string, any> {
  const [_header, payload, _signature] = jwt.split('.');
  const parsed = JSON.parse(atob(payload));

  if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
    throw new Error('JWT payload must be an object');
  }

  return parsed;
}
